exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gnav-h1{width:100%;max-width:350px;height:auto}.gnav-right{margin-right:0;width:100%;height:100%}.gnav-links{display:-webkit-box;display:-ms-flexbox;display:flex}.gnav-info-a{display:block;margin-top:.5em;width:auto;height:auto}.gnav-info-a .fa{margin-right:.2em}.gnav-info-open{display:-webkit-box;display:-ms-flexbox;display:flex}.gnav-info-span{display:inline}.gnav-menu,.gnav-menu-item:hover>.gnav-sub-list{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/navigation/NavigationStandard1/NavigationStandard1.m.scss
// module id = 1259
// module chunks = 15